import HomePageV1, { HomePageV1Props } from './HomePageV1';

const HomePageV2 = ({
  nextDrawDate,
  prizes,
}: Pick<HomePageV1Props, 'nextDrawDate' | 'prizes'>) => {
  return (
    <HomePageV1 withCountdown nextDrawDate={nextDrawDate} prizes={prizes} />
  );
};

export default HomePageV2;
